import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { getRoom } from '@evo/chat-core';

import { Layout } from '../../ui/layout';

import { Header } from './header';
import { Dialog } from './body/dialog';
import { List } from './body/list';

import * as aggr from './../../../libs/aggregation';
import { getSocketStore } from './../../../libs/utils';

const ChatView = (props) => {
    const { isInDialog, besida, closeDialog, backToChatList } = props;

    return besida ? (
        <Layout key='containerBesida' dataQa='besida_panel_block'>
            <Layout.Header>
                <Header
                    closeDialog={closeDialog}
                    backToChatList={backToChatList}
                />
            </Layout.Header>
            <Layout.Body>
                {isInDialog ? (
                    <Dialog
                        sendMsg={props.sendMsg}
                        retrySendMsg={props.retrySendMsg}
                        retrySendFile={props.retrySendFile}
                        retrySendFileCtx={props.retrySendFileCtx}
                        sendTyping={props.sendTyping}
                        sendCtx={props.sendCtx}
                        markMsgRead={props.markMsgRead}
                        chatMsgChange={props.chatMsgChange}
                        backToChatList={backToChatList}
                    />
                ) : <List openRoom={props.openRoom} />}
            </Layout.Body>
        </Layout>
    ) : <noscript key='emptySlotBesidaMain' />;
};

ChatView.propTypes = {
    isInDialog: PropTypes.bool,
    currentChatRoom: PropTypes.any,
    besida: PropTypes.object,
    markMsgRead: PropTypes.func,
    sendMsg: PropTypes.func,
    retrySendMsg: PropTypes.func,
    retrySendFile: PropTypes.func,
    retrySendFileCtx: PropTypes.func,
    sendTyping: PropTypes.func,
    sendCtx: PropTypes.func,
    closeDialog: PropTypes.func,
    openRoom: PropTypes.func,
    chatMsgChange: PropTypes.func,
    backToChatList: PropTypes.func,
};

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);
    const currentChatRoom = getRoom(socketStore, state.get('openedRoomIdent'));

    return {
        besida: state.get('besida'),
        isInDialog: aggr.isInDialog(currentChatRoom),
    };
};

export const Chat = connect(mapStateToProps)(ChatView);
